import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import HouseIcon from "@mui/icons-material/House";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";

const dotenv = require("dotenv");

const Form = () => {
  dotenv.config();

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          Swal.fire({
            icon: "success",
            title: "Message Sent Successfully",
          });
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Ooops, something went wrong",
            text: error.text,
          });
        }
      );
    e.target.reset();
  };

  const ColorButton = styled(Button)(() => ({
    color: "#fff",
    width: 220,
    height: 65,
    fontWeight: 700,
    fontSize: "18px",
    textTransform: "capitalize",
    borderRadius: "30px",
    backgroundColor: "#39484E",
    border: "2px solid #39484E",
    "&:hover": {
      color: "#39484E",
      backgroundColor: "#F6F4F0",
      borderColor: "#F6F4F0",
    },
  }));

  return (
    <Box margin={{ xs: "25% 0%", sm: "5% 0%" }}>
      <Typography
        variant={"body1"}
        fontWeight={400}
        textAlign={"left"}
        color={"#000"}
        paddingBottom={"1%"}
      >
        Have questions or want to learn more about our AIR Fund? Get in touch
        with us today! We welcome inquiries from individuals, organizations, and
        innovators interested in partnering with us to advance our mission.
      </Typography>
      <Box
        width={"100%"}
        margin={{ xs: "5% 0%", sm: "2% 0% 2% 0%" }}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        flexWrap={"wrap"}
      >
        <Box
          width={{ xs: "100%", sm: "68%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <form onSubmit={handleSubmit}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Name *"
                  variant="outlined"
                  name={"name"}
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  placeholder="Email *"
                  variant="outlined"
                  name={"email"}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  placeholder="Phone Number *"
                  variant="outlined"
                  name={"phone"}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  placeholder="Address *"
                  variant="outlined"
                  name={"address"}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  required
                  placeholder="Subject *"
                  variant="outlined"
                  name={"subject"}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  required
                  placeholder="Message *"
                  variant="outlined"
                  name={"message"}
                  fullWidth
                  multiline
                  rows={4}
                />
              </Grid>
              <Grid item container xs={12}>
                <Box width={"100%"}>
                  <ColorButton
                    size={"large"}
                    variant={"contained"}
                    type={"submit"}
                  >
                    Submit
                  </ColorButton>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
        <Box
          width={{ xs: "100%", sm: "30%" }}
          padding={{ xs: "5% 1%", sm: "2%" }}
        >
          <Box
            display="flex"
            justifyContent={"space-between"}
            alignItems={"center"}
            width={"100%"}
            marginTop={"4%"}
            marginLeft={{ xs: "0%", sm: "0%" }}
          >
            <Box width={"14%"} marginRight={3}>
              <Avatar
                variant="rounded"
                sx={{
                  bgcolor: "#fff",
                  border: " 2px dotted #CACACA",
                  padding: "5%",
                }}
              >
                <HouseIcon sx={{ color: "#39484E", width: 26, height: 26 }} />
              </Avatar>
            </Box>
            <Box width={"92%"}>
              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#000"}
              >
                Office Address
              </Typography>
              <Typography
                variant={"body2"}
                fontWeight={400}
                textAlign={"left"}
                color={"#000"}
              >
                42, Montgomery Road, Yaba, Lagos
              </Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            justifyContent={"space-between"}
            alignItems={"center"}
            width={"100%"}
            marginTop={"4%"}
            marginLeft={{ xs: "0%", sm: "0%" }}
          >
            <Box width={"14%"} marginRight={3}>
              <Avatar
                variant="rounded"
                sx={{
                  bgcolor: "#fff",
                  border: " 2px dotted #CACACA",
                  padding: "5%",
                }}
              >
                <EmailIcon sx={{ color: "#39484E", width: 26, height: 26 }} />
              </Avatar>
            </Box>
            <Box width={"92%"}>
              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#000"}
              >
                Send your mail at
              </Typography>
              <Typography
                variant={"body2"}
                fontWeight={400}
                textAlign={"left"}
                color={"#000"}
              >
                info@airfund.africa
              </Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            justifyContent={"space-between"}
            alignItems={"center"}
            width={"100%"}
            marginTop={"4%"}
            marginLeft={{ xs: "0%", sm: "0%" }}
          >
            <Box width={"14%"} marginRight={3}>
              <Avatar
                variant="rounded"
                sx={{
                  bgcolor: "#fff",
                  border: " 2px dotted #CACACA",
                  padding: "5%",
                }}
              >
                <PhoneIcon sx={{ color: "#39484E", width: 26, height: 26 }} />
              </Avatar>
            </Box>
            <Box width={"92%"}>
              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#000"}
              >
                Have Any Question
              </Typography>
              <Typography
                variant={"body2"}
                fontWeight={400}
                textAlign={"left"}
                color={"#000"}
              >
                +234 906 839 7033
              </Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            justifyContent={"space-between"}
            alignItems={"center"}
            width={"100%"}
            marginTop={"4%"}
            marginLeft={{ xs: "0%", sm: "0%" }}
          >
            <Box width={"14%"} marginRight={3}>
              <Avatar
                variant="rounded"
                sx={{
                  bgcolor: "#fff",
                  border: " 2px dotted #CACACA",
                  padding: "5%",
                }}
              >
                <AccessTimeIcon
                  sx={{ color: "#39484E", width: 26, height: 26 }}
                />
              </Avatar>
            </Box>
            <Box width={"92%"}>
              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#000"}
              >
                Working Hours
              </Typography>
              <Typography
                variant={"body2"}
                fontWeight={400}
                textAlign={"left"}
                color={"#000"}
              >
                Mon-Fri: 9.00am to 5.00pm
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Form;
